<ng-container *ngIf="initialized">

    <cr-create-customer-contract
            [customerId]="customerId"
            (onChangedObject)="handleObjectChange($event)"

    >
    </cr-create-customer-contract>

</ng-container>